import { makeAutoObservable, flow } from 'mobx';
import { getCityList } from '@/api/design';
import queryIPLocation from '&/utils/queryIPLocation';

const defaultCity = {
    name: '福州',
    code: '350100',
    level: '1',
    parent: '350000', // 福建code
};
class appPage {
    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    hotList = []; // 热门城市列表

    setHotList(arr) {
        this.hotList = arr;
    }

    cityList = []; //  城市列表

    setCityList(arr) {
        const tree = {};
        for (const item of arr) {
            const { initial } = item;
            if (tree[initial]) {
                tree[initial].items.push(item);
            } else {
                tree[initial] = {
                    title: initial,
                    key: initial,
                    items: [item],
                };
            }
        }
        this.cityList = Object.values(tree);
    }

    queryCityList = flow(function* () {
        if (!!this.cityList.length) return Promise.resolve();
        const { data = {} } = yield getCityList();
        this.setCityList(data.list);
        this.setHotList(data.hot);
    });

    clinetRegion = null; //   获取到的设备位置

    setClinetRegion(obj) {
        this.clinetRegion = obj;
    }

    selectedRegion = defaultCity; //  用户已选定的定位

    setSelectedRegion(obj) {
        this.selectedRegion = obj;
    }

    // 设置默认福州位置
    setInitRegion() {
        console.log('zx appPage setInitRegion 福州福州');
        this.selectedRegion = defaultCity;
    }

    isLoad = false; // 是否已经尝试过获取位置

    // 获取当前用户的行政区
    // @param force 强制刷新
    queryLocation = flow(function* (force = false, flag) {
        if (!force) {
            console.log('zx appPage queryLocation if !force=', !force, flag, this.isLoad, JSON.stringify(this.clinetRegion));
            if (this.clinetRegion) return Promise.resolve(this.clinetRegion);
            if (this.isLoad && !this.clinetRegion) { 
                console.log('zx appPage queryLocation if !force= reject', !force, flag, this.isLoad, JSON.stringify(this.clinetRegion));
                return Promise.reject(this.clinetRegion);
            }   
        } else {
            this.setClinetRegion(null); // 初始化
        }
        // IP获取定位
        try {
            const res = yield queryIPLocation();
            const data = res.result.ad_info;
            let adcode = data.adcode + '';

            const isProvince = adcode.slice(2) === '0000'; //直辖市

            const region = {
                name: data.city,
                code: adcode.slice(0, 4) + '00',
                level: isProvince ? '0' : '1',
                parent: isProvince ? '0' : adcode.slice(0, 2) + '0000',
                district: data.district,
            };
            this.setClinetRegion(region);
            return Promise.resolve(region);
        } catch (error) {
            console.log(error, '定位失败');
            return Promise.reject(new Error('获取定位失败'));
        } finally {
            this.isLoad = true;
        }

        //  经纬度定位

        /* try {
            const { coords } = yield getCoords();
            const { data = [] } = yield getGeoInfo({
                lng: coords.longitude,
                lat: coords.latitude,
            });
            data.sort((a, b) => a.level - b.level);
            this.setGeo(data);
            if (!data.length)
                throw new Error('调用逆地理编码接口,未获取到定位');
            return Promise.resolve(data);
        } catch (error) {
            return Promise.reject(error);
        } finally {
            this.isLoad = true;
        } */
    });

    cacheProxyIds = new Set([]);

    addCache(id) {
        this.cacheProxyIds.add(id);
    }

    barHeight = 0; // app状态栏高,0表示不包含状态栏高

    setBarHeight(height) {
        this.barHeight = height ? +height : 0;
        localStorage.setItem('barHeight', this.barHeight);
    }
}

export default new appPage();
